import React, { ComponentProps } from 'react';
import { ResourceMultiSelect } from '../../ResourceSelect';
import RequestBuilder from 'Resources/RequestBuilder';
import ComparisonTypes from 'Resources/ComparisonTypes';
import Resource from 'Resources/Resource';

export type OptinsSelectProps = Omit<
	ComponentProps<typeof ResourceMultiSelect>,
	'resource' | 'multi' | 'onClear' | 'onRemove' | 'titleField'
> & {
	optinType?: string;
};

const OptinsSelect = ({ optinType, ...selectProps }: OptinsSelectProps) => {
	const OptIn = Tools.OptIn as Resource;

	const modifyRb = (rb: RequestBuilder) => {
		if (optinType) {
			rb.addFilter(OptIn.attr.type, ComparisonTypes.Equals, optinType);
		}

		rb.addSort(OptIn.attr.title, true);
		selectProps.modifyRb?.(rb);
	};

	return (
		<ResourceMultiSelect
			resource={OptIn}
			hideSelected
			titleField={'title' as 'name'}
			{...selectProps}
			modifyRb={modifyRb}
		/>
	);
};

export default OptinsSelect;
